import React, { useState } from 'react';
import { translate } from '../Services/translation';

const CartBonusCollapse = ({
  onSetBonus,
  imageUrl,
  bonusToEarn,
  bonusBalance,
  errorMessage,
  bonusUsed,
  orderCurrency,
  enjoyClubDescription,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [bonusValue, setBonusValue] = useState(bonusUsed);

  function bonusChange({ target }) {
    setBonusValue(target.value);
  }

  function onSubmit(e) {
    e.preventDefault();
    onSetBonus(Number(bonusValue));
  }

  return (
    <>
      <div className="card-bonus">
        <div className="card-bonus__image">
          <img src={imageUrl} alt="bonus image" />
        </div>

        <div className="card-bonus__use">
          <div className="card-bonus__use__description">
            <p>
              {translate('checkout.cart.bonus.your_points')}: {bonusBalance}
            </p>
          </div>
          <form className="card-bonus__use__control" onSubmit={onSubmit}>
            <input
              className="card-bonus__use__control__input"
              value={bonusValue}
              onChange={bonusChange}
              type="number"
              size="10"
            />
            <input
              type="submit"
              className="button card-bonus__use__control__button"
              data-toggle="tooltip"
              value={translate('checkout.cart.bonus.use_button')}
            />
          </form>
          <div className="bonus-input__item">
            <p className="bonus-input__item__error">{errorMessage}</p>
          </div>
        </div>
        <div className="card-bonus__calculations">
          <h4>
            - {bonusUsed.toFixed(2)} {orderCurrency}
          </h4>
        </div>
      </div>
      <div className="card-bonus-info">
        <div className="columns">
          {translate('checkout.cart.bonus.you_will_get').replace(
            '{0}',
            bonusToEarn
          )}
        </div>

        <div
          className={`columns collapse-block__header ${
            isOpen ? 'collapse-block__header-open' : ''
          }`}
          onClick={(_) => setIsOpen(!isOpen)}
        >
          {translate('checkout.cart.bonus.bonus_text')}
        </div>
        {enjoyClubDescription && (
          <div
            className={`columns small-12 collapse-block__content ${
              isOpen ? 'collapse-block__content-open' : ''
            }`}
            dangerouslySetInnerHTML={{
              __html: enjoyClubDescription.value,
            }}
          ></div>
        )}
      </div>
    </>
  );
};

export default CartBonusCollapse;
